import React from "react";
import { NavLink } from "react-router-dom";

import { FaHome, FaMapMarkedAlt, FaClipboardList } from "react-icons/fa";
import { MdInsertChart, MdDashboard } from "react-icons/md";
import { BsTrainFrontFill } from "react-icons/bs";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";
import { GiCoalWagon } from "react-icons/gi";
import logo from "../.././img/Rs.png";
import { useGlobalContext } from "../Context/GlobalContext";
import UserInfo from "./User/UserInfo";
import StrokeTextAnimation from "../Extra/StrokeAnimation";

const NavbarBtns = () => {
  const { userData } = useGlobalContext();

  const menuItems = [
    {
      title: "Home",
      path: "/",
      icon: <FaHome />,
    },
    {
      title: "Dashboard",
      path: "/Dashboard",
      icon: <MdDashboard />,
    },
    {
      title: "Block Dashboard",
      path: "/BlockDashboard",
      icon: <BsTrainFrontFill />,
    },
    {
      title: "CMS Dashboard",
      path: "/CMS",
      icon: <GrUserWorker />,
    },
    {
      title: "Station Map",
      path: "/StationMap",
      icon: <FaMapMarkedAlt />,
    },
    {
      title: "Clearance And Supply",
      path: "/ClearanceAndSupply",
      icon: <GiCoalWagon />,
    },
    {
      title: "Store",
      path: "/Store",
      icon: <FaClipboardList />,
    },
    {
      title: "Insert Data",
      path: "/InsertData",
      icon: <MdInsertChart />,
    },
  ];

  return (
    <div
      className="d-flex flex-column"
      style={{
        width: "100%",
        // height: "100vh",
        // maxHeight: "98vh",
        overflow: "hidden",
        background: "#f8fafc",
      }}
    >
      {/* ================================================= */}
      {/* HEADER */}
      {/* ================================================= */}
      <div
        className="border-bottom ps1 pe-1"
        style={{
          height: "60px",
          minHeight: "60px",
          flexShrink: 0,
          borderRadius: "10px",
          background:
            "linear-gradient(120deg, #063b87 0%, #0a57bb 45%, #087344 100%)",
        }}
      >
        <div className=" w-100 ">
          {/* Logo */}
          <div className="  " style={{}}>
            <StrokeTextAnimation text="Rail-Setu" />
          </div>
        </div>
      </div>

      {/* ================================================= */}
      {/* MAIN AREA */}
      {/* ================================================= */}
      <div
        className="d-flex flex-column justify-content-between flex-grow-1"
        style={{
          minHeight: 0,
          height: "100%",
          overflow: "hidden",
        }}
      >
        {/* ================================================= */}
        {/* NAVIGATION - 75% */}
        {/* ================================================= */}
        <div
          style={{
            // height: userData ? "68%" : "100%",
            flexShrink: 0,
            overflow: "hidden",
          }}
        >
          <div
            className="h-90 px-2"
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              scrollbarWidth: "thin",
            }}
          >
            {/* Navigation title */}
            <div className="px-3 pt-3 mb-2">
              <small
                className="text-uppercase text-muted fw-semibold"
                style={{
                  fontSize: "10px",
                  letterSpacing: "1px",
                }}
              >
                Navigation
              </small>
            </div>

            {/* ================= MENU ================= */}
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className="text-decoration-none d-block"
              >
                {({ isActive }) => (
                  <div
                    className="d-flex align-items-center px-3 py-2 mb-1"
                    style={{
                      minHeight: "44px",
                      width: "100%",
                      borderRadius: "10px",

                      background: isActive ? "#eaf2ff" : "transparent",

                      color: isActive ? "#2275f1" : "#4b5563",

                      fontWeight: isActive ? "600" : "500",

                      transition: "background 0.2s ease, color 0.2s ease",

                      boxSizing: "border-box",
                    }}
                  >
                    {/* Active indicator */}
                    <div
                      style={{
                        width: "3px",
                        height: isActive ? "25px" : "0",
                        flexShrink: 0,
                        borderRadius: "10px",
                        background: "#2275f1",
                        marginRight: isActive ? "10px" : "13px",
                        transition: "all 0.2s ease",
                      }}
                    />

                    {/* Icon */}
                    <span
                      className="d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "28px",
                        fontSize: "18px",
                      }}
                    >
                      {item.icon}
                    </span>

                    {/* Text */}
                    <span
                      className="ms-2 text-truncate"
                      style={{
                        fontSize: "14px",
                        minWidth: 0,
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                )}
              </NavLink>
            ))}

            {/* ================= ADMIN ================= */}
            {userData?.role === "admin" && (
              <div className="mt-3 pb-3">
                {/* Admin divider */}
                <div className="d-flex align-items-center gap-2 px-3 mb-2">
                  <div
                    className="flex-grow-1"
                    style={{
                      height: "1px",
                      background: "#e5e7eb",
                    }}
                  />

                  <small
                    className="text-muted"
                    style={{
                      fontSize: "9px",
                    }}
                  >
                    ADMIN
                  </small>

                  <div
                    className="flex-grow-1"
                    style={{
                      height: "1px",
                      background: "#e5e7eb",
                    }}
                  />
                </div>

                {/* Admin button */}
                <NavLink
                  to="/adminPanel"
                  className="text-decoration-none d-block"
                >
                  {({ isActive }) => (
                    <div
                      className="d-flex align-items-center px-3 py-2"
                      style={{
                        minHeight: "44px",
                        borderRadius: "10px",

                        color: isActive ? "#dc2626" : "#6b7280",

                        background: isActive ? "#fef2f2" : "transparent",

                        fontWeight: isActive ? "600" : "500",
                      }}
                    >
                      <span
                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                        style={{
                          width: "28px",
                          fontSize: "18px",
                        }}
                      >
                        <GrUserAdmin />
                      </span>

                      <span
                        className="ms-2 text-truncate"
                        style={{
                          fontSize: "14px",
                          minWidth: 0,
                        }}
                      >
                        Admin Panel
                      </span>
                    </div>
                  )}
                </NavLink>
              </div>
            )}
          </div>
        </div>

        {/* ================================================= */}
        {/* USER PROFILE - 25% */}
        {/* ================================================= */}
        {userData && (
          <div
            style={{
              // height: "25%",
              minHeight: 0,
              flexShrink: 0,

              overflow: "hidden",

              background: "#fff",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <UserInfo />
          </div>
        )}
      </div>
    </div>
  );
};

export default NavbarBtns;
